import {withStyles} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import Button from "@material-ui/core/Button";
import React from "react";
import MenuItem from '@material-ui/core/MenuItem';
import {Locales} from "../App";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SKIcon from "../Static/flags/Flag_of_Slovakia.svg";
import CZIcon from "../Static/flags/Flag_of_the_Czech_Republic.svg";
import ENIcon from "../Static/flags/anglicka-vlajka-union-jack-i135.svg";

const StyledMenu = withStyles({
	paper: {
		border: '1px solid #d3d4d5',
	},
})(props => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'center',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'center',
		}}
		{...props}
	/>
));

const StyledButton = withStyles({
	root: {
		position: 'absolute',
		top: '0',
		right: '5px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#eeeeee',
		minWidth: '40px',
		"&:hover": {
			backgroundColor: '#cacaca'
		}
	},
})(Button);

const StyledListItemIcon = withStyles({
	root: {
		maxWidth: '30px',
		minWidth: '30px'
	}
})(ListItemIcon);

const StyledMenuItem = withStyles(theme => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'&:focus': {
			backgroundColor: theme.palette.primary.main,
			'& .MuiListItemIcon-root, & .MuiListItemText-primary': {
				color: theme.palette.common.white,
			},
		},
	},
}))(MenuItem);

class ChangeLocale extends React.PureComponent {
	state = {
		isOpen: false,
		anchorEl: null
	};

	openDropdown = (event) => {
		this.setState({
			isOpen: true,
			anchorEl: event.currentTarget
		});
	};

	closeDropdown = (locale) => {
		if (locale === Locales.SK) {
			this.props.changeLocale(Locales.SK);
		} else if (locale === Locales.CZ) {
			this.props.changeLocale(Locales.CZ);
		} else if (locale === Locales.EN) {
			this.props.changeLocale(Locales.EN);
		}

		this.setState({
			isOpen: false,
			anchorEl: null,
		});
	};

	getFlag = () => {
		const { locale } = this.props;
		if (locale === Locales.EN) {
			return ENIcon;
		} else if (locale === Locales.CZ) {
			return CZIcon;
		}

		return SKIcon;
	};

	render() {
		const { isOpen, anchorEl } = this.state;
		const currentFlag = this.getFlag();

		return (
			<div className='dropdown'>
				<StyledButton
					aria-controls="customized-menu"
					aria-haspopup="true"
					variant="contained"
					color="secondary"
					onClick={this.openDropdown}
				>
					<img className='flag' src={currentFlag} alt='' />
				</StyledButton>
				<StyledMenu
					id="customized-menu"
					anchorEl={anchorEl}
					keepMounted
					open={isOpen}
					onClose={this.closeDropdown}
				>
					<StyledMenuItem onClick={() => this.closeDropdown(Locales.SK)}>
						<StyledListItemIcon>
							<img className='flag' src={SKIcon} alt='' />
						</StyledListItemIcon>
					</StyledMenuItem>
					<StyledMenuItem onClick={() => this.closeDropdown(Locales.CZ)}>
						<StyledListItemIcon>
							<img className='flag' src={CZIcon} alt='' />
						</StyledListItemIcon>
					</StyledMenuItem>
					<StyledMenuItem onClick={() => this.closeDropdown(Locales.EN)}>
						<StyledListItemIcon>
							<img className='flag' src={ENIcon} alt='' />
						</StyledListItemIcon>
					</StyledMenuItem>
				</StyledMenu>
			</div>
		);
	}
}

export default ChangeLocale;
